<div class="w-full mx-auto h-auto py-1 ">
  <app-captcha class="relative w-full" (onCaptchaCheck)="captchaCapture($event)"></app-captcha>
</div>
